import type { CalendarDate } from '@internationalized/date';
import type { CalendarState } from '@react-stately/calendar';
import { createContext, useContext } from 'react';
import type { AriaButtonProps } from 'react-aria';

/**
 * Calendar state context for SgDatePicker
 * Contains calendar-related state and props from React ARIA
 */
export interface DatePickerCalendarContextValue {
  calendarState: CalendarState;
  calendarProps: React.HTMLAttributes<HTMLElement>;
  prevButtonProps: AriaButtonProps<'button'>;
  nextButtonProps: AriaButtonProps<'button'>;
  title: string;
  inputValue: string;
  isDateUnavailable?: (date: CalendarDate) => boolean;
}

const DatePickerCalendarContext = createContext<DatePickerCalendarContextValue | undefined>(undefined);

export const DatePickerCalendarProvider = DatePickerCalendarContext.Provider;

export function useDatePickerCalendar(): DatePickerCalendarContextValue {
  const context = useContext(DatePickerCalendarContext);

  if (!context) {
    throw new Error('useDatePickerCalendar must be used within DatePickerCalendarProvider');
  }

  return context;
}
